import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseDashboardFiltersComponent } from '../base-dashboard-filters.component';
import { GaValidateService } from '../../../../../shared/formly/ga-validate.service';
import { GaMessageService } from '../../../../../shared/message/ga-message.service';
import { TranslationService } from '../../../../../shared/translation/translation.service';
import { ReportDataService } from '../../../../../shared/report/report-data.service';
import { ReportFiltersUtil } from '../../../../../shared/report/report-filters-util.service';
import { DashboardService } from '../../dashboard.service';
import { GaDeferredService } from '../../../../../shared/services/ga-deferred.service';
import { AuthService } from '../../../../../shared/services/auth/auth.service';
import { Override } from '../../../../../shared/app-decorators';
import { util } from '../../../../../shared/util';
import { IObject } from '../../../../../../type_definitions/datatypes';

@Component({
  selector: 'lbdm-dashboard-filters',
  templateUrl: '../base-dashboard-filters.component.html'
})
export class LbdmDashboardFiltersComponent extends BaseDashboardFiltersComponent {
  public displayFilters:boolean = false;
  public autoSearch:boolean = true;

  constructor(
    validateService:GaValidateService,
    messageService:GaMessageService,
    translationService:TranslationService,
    reportDataService:ReportDataService,
    reportFiltersUtil:ReportFiltersUtil,
    dashboardService:DashboardService,
    deferredService:GaDeferredService,
    authService:AuthService,
    cdr:ChangeDetectorRef
  ) {
    super(validateService, messageService, translationService, reportDataService, reportFiltersUtil, dashboardService, deferredService, authService, cdr);
  }

  @Override(BaseDashboardFiltersComponent)
  public startSearch():void {
    if (!this.companyCountryId && !this.countryId) {
      this.messageService.showErrorDialog(this.translationService.instant('GA.VALIDATION.VALIDATION_FAILED'), 'BP company country id and BP country id is mandatory');
    } else {
      const filters:IObject = util.deepClone({
        companyCountryId: this.companyCountryId,
        countryId: this.countryId
      });

      this.onSearch.emit(filters);
    }
  }
}